// extracted by mini-css-extract-plugin
export default {"dropDown":"PhotobooksDropdownMenu_dropDown__4CYiT"};